import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { toLocalDate2 } from "../../../utils";
import { DETAILS_APIS, MANAGEMENT_APIS, REPORT_APIS } from "../../../common/apis";
import UnitAdhocReportTable from "./UnitAdhocReportTable";
import { ExcelIcon } from "../../../icons/ButtonIcons";
import { DataGridAction } from "../../../components/DataTable";
import { useWindowPopups, WindowTypes } from "../../../components/useWindowPopups";

export default function AdhocComponentReport({ allData }) {

  const { get, getFile } = useFetch();

  const [componentDetails, setComponentDetails] = useState({});
  const [localData, setLocalData] = useState({});
  const [componentAdHocData, setComponentAdHocData] = useState({});

  async function adHocComponentExcelClick() {
    await getFile(`${MANAGEMENT_APIS?.EXPORT_COMPONENT_ADHOC_REPORT}?componentId=${allData?.ComponentId || localData?.ComponentId}`, "COMPONENT ADHOC REPORT");
  }
  async function exportAdhocReport(row) {
    await getFile(`${REPORT_APIS?.VIEW_SPECIAL_MAIL_REPORT}?reportNumber=${row?.ReportNumber}`, "Adhoc Report File");
  }
  async function editAdhocReport(row) {
    var actionName = 'edit-special-component-report';
    if (Object.values(WindowTypes).includes(actionName)) {
      HandleNewWindow(actionName, row);
      return;
    }
  }


  const HandleNewWindow = (actionName, data) => {
    useWindowPopups(actionName, data)
  }
  async function getData(formDatas) {
    let resData = await get(`${DETAILS_APIS?.COMPONENT_HISTORY}?componentId=${formDatas?.ComponentId || 0}&ResultsView=0`);
    if (resData) {
      setComponentDetails(resData?.ComponentHistorySimpleHeader[0] || {})
    }
    let res = await get(`${MANAGEMENT_APIS?.COMPONENT_ADHOC_REPORT}?componentId=${formDatas?.ComponentId || 0}`);
    if (res) {
      setComponentAdHocData(res);
    }
  }
  //get data for grid
  useEffect(() => {
    (async function () {
      let formDatas = JSON.parse(localStorage.getItem("recent-component-results"));

      if (formDatas !== null && formDatas !== undefined) {
        setLocalData(formDatas);
        getData(formDatas)
      }

      if (allData?.UnitId > 0) {
        getData(allData)
      }

    })();
  }, []);


  useEffect(() => {
    function handleStorageChange(event) {
      if (event.key === "adhoc-report-refresh" && event.newValue === "true") {
        // Refresh data
        const stored = JSON.parse(localStorage.getItem("recent-unit-results"));
        if (stored) {
          setLocalData(stored);
          getData(stored);
        } else if (allData?.UnitId > 0) {
          getData(allData);
        }

        localStorage.removeItem("adhoc-report-refresh");
      }
    }

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [allData]);


  return (
    <>
      <Grid container minWidth={"66vw"}>

        <Grid item xs={12}>
          <Typography >{`${componentDetails?.Product || ""} ${componentDetails?.Customer || ""} ${componentDetails?.Site || ""} ${componentDetails?.Unit || ""} ${componentDetails?.UnitModelFormatted || ""} ${componentDetails?.Component || ""}`}</Typography>
          {/* <Typography >{`Default Oil ${componentDetails?.Product || ""} Default Testset ${componentDetails?.Product || ""}`}</Typography> */}
        </Grid>
        {componentAdHocData.length > 0 &&
          <Grid item xs={6}>
            <Tooltip
              title="Export Component Adhoc Report Table"
              arrow
            >
              <span>

                <Button
                  sx={{ mt: 1 }}
                  onClick={adHocComponentExcelClick}
                  startIcon={<ExcelIcon />}
                  disabled={!(allData?.ComponentId > 0 || localData?.ComponentId > 0)}
                >
                  Export
                </Button>
              </span>
            </Tooltip>
          </Grid>}
        <Grid item xs={12} mt={0.2} mb={0}>
          <Typography variant="subtitle2" mb={0}>
            Total Records: <b> {componentAdHocData.length}</b>
          </Typography>
        </Grid>
        <Grid item xs={12} mt={0.5}>
          <UnitAdhocReportTable
            columns={GetColumns(exportAdhocReport, editAdhocReport)}
            data={componentAdHocData}
          />
        </Grid>
      </Grid>
    </>
  );
}


const GetColumns = (exportAdhocReport, editAdhocReport) => [
  {
    headerName: "ReportNumber",
    field: "ReportNumber",
    width: 100,
  },
  {
    headerName: "AdHoc Report Type",
    field: "AdHocReportType",
    width: 150,
  },
  {
    headerName: "Type Short",
    field: "AdHocReportTypeShort",
    width: 100,
  },
  {
    headerName: "Site",
    field: "Site",
    width: 150,
  },
  {
    headerName: "Billing Rate",
    field: "BillingRate",
    width: 100,
  },
  {
    headerName: "Hours",
    field: "Hours",
    width: 100,
  },
  {
    headerName: "IsArchived",
    field: "IsArchived",
    width: 100,
    valueFormatter: ({ value }) => (value ? "True" : "False"),
  },

  {
    headerName: "IsExternal",
    field: "IsExternal",
    width: 100,
    valueFormatter: ({ value }) => (value ? "True" : "False"),
  },
  {
    headerName: "Sampled",
    field: "Sampled",
    width: 100,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },
  {
    headerName: "Created",
    field: "Created",
    width: 120,
    valueFormatter: ({ value }) => toLocalDate2(value),
  },
  {
    headerName: "Action",
    field: "AdhocReport",
    sortable: false,
    minWidth: 145,
    renderCell: function ({ row }) {
      return (
        <>
          <DataGridAction row={row} onClick={editAdhocReport} label="Edit" sx={{ mr: 0.2 }} />

          {row?.HasAdHocReport &&
          <Tooltip title="Export Adhoc Report File" arrow>
            <span>
            <DataGridAction row={row} onClick={exportAdhocReport} label="Export" />
            </span>
            </Tooltip>
          }
        </>
      );
    },
  },
];
